import styled from 'styled-components';

export const Container = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.5;
`;

export const Line = styled.span`
  display: block;
`;
